module.exports = __webpack_public_path__ + "static/media/DC_F_Timeless_Sforza_DKGold.d0c252d0.png";